// extracted by mini-css-extract-plugin
export default {"label":"label--BkrwUgAct0PR5QGDp1g0","input":"input--Prg3oN1cvh0jaAAxiRyY"};